// extracted by mini-css-extract-plugin
export default {"cta-section":"Cta_cta-section__siSM2","cta-content":"Cta_cta-content__bKXrb"};